/* global axios*/
const http = {
	el: {
		search: document.querySelector('.search'),
		newsContainer: document.querySelector('.js-get-news')
	},

	fxPreloaderFilterAddHelper(spinnerElement, el) {
		spinnerElement.innerHTML = ''
		spinnerElement.classList.add('is-loading')
		spinnerElement.innerHTML += '<div class="is-loading-spinner"></div>'
		el.closest('.js-search').querySelector('.pagination').style.display = 'none'
		el.querySelector('.filter-search__text').style.display = 'none'
		this.el.search.querySelector('.search-results__article') && this.el.search.querySelectorAll('.search-results__article').forEach(el => el.style.display = 'none')
	},

	fxPreloaderFilterRemoveHelper(spinnerElement, el) {
		spinnerElement.classList.remove('is-loading')
		spinnerElement.removeAttribute('style')
		spinnerElement.innerHTML = ''
		el.closest('.js-search').querySelector('.pagination').removeAttribute('style')
		el.querySelector('.filter-search__text').removeAttribute('style')
		this.el.search.querySelector('.search-results__article') && this.el.search.querySelectorAll('.search-results__article').forEach(el => el.removeAttribute('style'))
	},

	fxpreloaderAddHelper(spinnerElement) {
		spinnerElement.classList.add('is-loading')
		spinnerElement.innerHTML += '<div class="is-loading-spinner"></div>'
	},

	fxpreloaderRemoveHelper(spinnerElement) {
		spinnerElement.classList.remove('is-loading')
		spinnerElement.querySelector('.is-loading-spinner').outerHTML = ''
	},

	fxPreloader() {
		// Add a request interceptor
		axios.interceptors.request.use(config => {

			if (this.el.search.classList.contains('is-search-open')) {
				document.querySelectorAll('.filter-search').forEach(el => {
					const spinnerElement = el.nextElementSibling
					this.fxPreloaderFilterAddHelper(spinnerElement, el)
				})
			}

			else if (document.querySelectorAll('.filter-search').length > 1 && !this.el.search.classList.contains('is-search-open')) {
				document.querySelectorAll('.filter-search').forEach(el => {
					const spinnerElement = el.nextElementSibling.classList.contains('search-results') ? el.nextElementSibling : el.nextElementSibling.children[0]
					this.fxPreloaderFilterAddHelper(spinnerElement, el)
				})
			}

			else {
				this.el.newsContainer && this.fxpreloaderAddHelper(document.querySelector('.js-get-news .media__list'))
				document.querySelectorAll('.js-form-contact .js-submit').forEach(el => this.fxpreloaderAddHelper(el))
			}

			return config

		}, error => Promise.reject(error))

		// Add a response interceptor
		axios.interceptors.response.use(response => {
			// Any status code that lie within the range of 2xx cause this function to trigger
			// Do something with response data
			if (this.el.search.classList.contains('is-search-open')) {
				document.querySelectorAll('.filter-search').forEach(el => {
					const spinnerElement = el.nextElementSibling
					this.fxPreloaderFilterRemoveHelper(spinnerElement, el)
				})

			}

			else if (document.querySelectorAll('.filter-search').length > 1 && !this.el.search.classList.contains('is-search-open')) {
				document.querySelectorAll('.filter-search').forEach(el => {
					const spinnerElement = el.nextElementSibling.classList.contains('search-results') ? el.nextElementSibling : el.nextElementSibling.children[0]
					this.fxPreloaderFilterRemoveHelper(spinnerElement, el)
				})
			}

			else {
				this.el.newsContainer && this.fxpreloaderRemoveHelper(document.querySelector('.js-get-news .media__list'))
				document.querySelectorAll('.js-form-contact .js-submit').forEach(el => this.fxpreloaderRemoveHelper(el))
			}

			return response
		}, error => Promise.reject(error))
	},

	fxPost(endpoint, formData, callback) {
		return axios.post(endpoint, formData)
			.then(result => {
				callback(result)
				return result
			})
			.catch(error => callback({ ...error }))
	},

	fxGet(endpoint, callback) {
		return axios.get(endpoint)
			.then(result => {
				callback(result)
				return result
			})
			.catch(error => callback({ ...error }))
	}
}

http.fxPreloader()